export * from './TabDepartmentsResultsSurvey';
